export default __webpack_public_path__ + "static/media/terminal.601102c6.PNG";